import { type GoogleMarker } from "../../SalesPartner/salesPartnerTypes";
import { COOKIE_NAMES, deletePreferredPartnerCookie } from "./utils";
import { getCookie } from "../../utils/cookie";
import {
  getSavedAffiliatePartner_toBeRemoved,
  getSavedSubsidiaryId_toBeRemoved,
} from "~/feature/Affiliate/utilsToRefactorOut";

export const hasActiveSelectedSubsidiary = (
  list: GoogleMarker[],
  selectedSubsidiaryId = getSavedSubsidiaryId_toBeRemoved()
): boolean => {
  if (!selectedSubsidiaryId) {
    return false;
  }

  // find at least one subsidiary
  return list.some((marker) => marker.subsidiaryId === selectedSubsidiaryId);
};

export const makersWithPreferredSalesPartner = (
  list: GoogleMarker[],
  affiliateId: string,
  selectedSubsidiaryId = getSavedSubsidiaryId_toBeRemoved()
): GoogleMarker[] => {
  // check if requires to activate the filtering system
  if (!affiliateId || list.length === 0 || !hasActiveSelectedSubsidiary(list, selectedSubsidiaryId)) {
    return list;
  }

  // grab the default selected Subsidiary
  const id = selectedSubsidiaryId ?? "";

  // filter an return
  return list
    .filter((marker) => marker.subsidiaryId === id)
    .concat(list.filter((marker) => marker.subsidiaryId !== id));
};

export const clearSavedSalesPartnerCookieOnAccountUncheck = () => {
  const savedPartner = getSavedAffiliatePartner_toBeRemoved();
  const cookie = getCookie(COOKIE_NAMES.PARTNER)?.value;
  if (savedPartner && savedPartner.affiliateId === cookie) {
    deletePreferredPartnerCookie();
  }
};
